import * as types from './mutation_types';
import {API_ENTRYPOINT} from "../../../config/entrypoint";
import fetch from "../../../utils/fetch";

export const reset = ({ commit }) => {
  commit(types.CITY_RESET);
};

export const loadItems = ({commit, dispatch}) => {
  commit(types.CITY_SET_LOADING, true);
  const url = new URL("api/cities/", API_ENTRYPOINT);

  return fetch(url, {dispatch: dispatch})
    .then((response) => response.json())
    .then((data) => {
      commit(types.CITY_SET_LOADING, false);
      commit(types.CITY_SET_ITEMS, data['member']);
    })
    .catch((e) => {
      commit(types.CITY_SET_LOADING, false);
      commit(types.CITY_SET_ERROR, e.message);
    });
};

export const loadItem = ({commit, dispatch}, id) => {
  commit(types.CITY_SET_LOADING, true);
  const url = new URL("api/cities/"+id, API_ENTRYPOINT);

  return fetch(url, {dispatch: dispatch}, id)
    .then((response) => response.json())
    .then((data) => {
      commit(types.CITY_SET_LOADING, false);
      commit(types.CITY_SET_ITEM, data);
    })
    .catch((e) => {
      commit(types.CITY_SET_LOADING, false);
      commit(types.CITY_SET_ERROR, e.message);
    });
};

export const updateItem = ({commit, dispatch}, values) => {
  if (!values.id) {
    console.error('Missing user id in values for PATCH /pokemon');
  }
  const url = new URL(
    "/api/cities/{id}".replace('{id}', values.id),
    API_ENTRYPOINT
  );

  delete values['id'];

  return fetch(url, {dispatch, method: 'PATCH', body: JSON.stringify(values)})
    .then((data) => {
      commit(types.CITY_SET_LOADING, false);
      commit(types.CITY_SET_ITEM, data);
    })
    .catch((e) => {
      commit(types.CITY_SET_LOADING, false);
      commit(types.CITY_SET_ERROR, e.message);
    });
};

export const fetchObject = ({commit, dispatch},obj) => {
    commit(types.CITY_SET_LOADING, true);

    if (obj.method === 'GET'){
      return fetch(obj.url, {dispatch: dispatch})
        .then((response) => response.json())
        .then((data) => {
          commit(types.CITY_SET_LOADING, false);
          return data;
        })
        .catch((e) => {
          commit(types.CITY_SET_LOADING, false);
          commit(types.CITY_SET_ERROR, e.message);
        });
    }
    // OTHER
    return fetch(obj.url, {method: obj.method, body: JSON.stringify(obj.obj), dispatch: dispatch})
      .then((response) => response.json())
      .then((data) => {
        commit(types.CITY_SET_LOADING, false);
        return data;
      })
      .catch((e) => {
        commit(types.CITY_SET_LOADING, false);
        commit(types.CITY_SET_ERROR, e.message);
      });
};
